import React from "react";
import Hero from "../Components/Hero/Hero";
import Blog from "../Components/Blog/Blog";
const journal = () => {
  return (
    <div className="home_page">
      <Hero />
      <Blog />
    </div>
  );
};

export default journal;
